// Auto-generated translation for da.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:13:18.822109+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "Til hejere",
    title: "Alt til din hest. I én app.",
    subtitle: "Administrer sundhed, træning, planlægning og fagfolk fra ét overskueligt dossier.",
    primaryCTA: {
      label: "Start gratis",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Hesteprofil — vægt, vaccination, EquiCoach, foder og træning på ét skærmbillede",
      caption: "Din hest, komplet overblik.",
    },
    problem: "Du holder sandsynligvis aftaler, fotos, træning, foder og sundhed spredt ud — i WhatsApp-grupper, skokasser og løse apps. Det giver dig dårligt overblik.",
    solution: "EquiSight gør din hest til ét komplet digitalt dossier, der følger dig overalt.",
    benefits: [
      "Én komplet hesteprofil pr. hest",
      "Sundhed, smed, tandlæge og fysioterapeut på ét sted",
      "Kalender med smarte påmindelser",
      "Fotos, noter og historik uden begrænsning",
      "Backup af alle dine data med Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 hest · altid gratis",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Flere heste + backup",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar til at begynde?",
      title: "Start i dag med din første hest.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "Flere heste. Bedre overblik. Større sikkerhed.",
    subtitle: "Opgrader til Premium og administrer alle dine heste uden begrænsninger — med fuld EquiCoach intelligens.",
    primaryCTA: {
      label: "Start 14 dages gratis prøveperiode",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Alle priser",
      href: "/#pricing",
    },
    audience: "Til ejere, sportsryttere og hestemænd med flere heste.",
    features: [
      "Tilføj ubegrænset antal heste",
      "Komplet historik pr. hest",
      "Datasikkerhedskopiering",
      "Udvidede EquiCoach indsigter",
      "Smarte notifikationer og planlægning",
      "Sundhed og træning fuldt sammenkoblet",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Mindre end €0,17 pr. dag",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Opgrader til Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "Til rideskole-ryttere",
    title: "Bliv bedre, selv uden egen hest.",
    subtitle: "Følg dine lektioner, træninger og udvikling i EquiSight — for mindre end en kop kaffe om måneden for mor eller far. Eller en lækker is med flødeskum.",
    primaryCTA: {
      label: "Start med Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Hvordan virker det?",
      href: "#features",
    },
    problem: "Som rideskole-rytter har du ofte ikke din egen hest, men du vil stadig udvikle dig og have overblik over dine lektioner, mål og de heste, du rider på.",
    solution: "Rideskolefunktionalitet er som standard inkluderet i Premium — følg din egen udvikling og se de tilknyttede rideskoleheste i skrivebeskyttet tilstand.",
    features: [
      "Hold styr på træninger",
      "Sæt mål",
      "Følg fremskridt",
      "Se rideskoleheste med navn og foto",
      "Ingen adgang til private sundhedsdata",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per måned · rideskolefunktionalitet inkluderet",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Bliv medlem",
      title: "Start som rideskole-rytter.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "Til ridecentre & stalde",
    title: "Gør dit ridecenter digitalt tilgængeligt for enhver rytter.",
    subtitle: "Giv ryttere tilknytning til heste, lektioner og fremgang — uden at dele følsomme staldddata.",
    primaryCTA: {
      label: "Anmod om adgang",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se moduler",
      href: "#features",
    },
    audience: "EquiSight hjælper ridecentre og stalde med at fastholde rytternes engagement længere og skille sig ud digitalt.",
    features: [
      "Gør ridecenterets heste synlige for ryttere",
      "Navn og foto pr. hest",
      "Tilknyt ryttere til heste",
      "Skrivebeskyttet adgang til følsomme data",
      "Lektions- og træningshistorik samlet ét sted",
      "Brugerstyring med roller",
    ],
    benefits: [
      "Større tilknytning til ryttere",
      "Mere professionelt udtryk",
      "Ekstra digital service til medlemmer",
      "Ny indtægtskilde via app-brug",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Pr. måned · ridecenter-funktionalitet inkluderet for ryttere",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktivér Ridecenter-modulet.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Avlsmodul",
    title: "Styr på cyklus, drægтighed og føludvikling.",
    subtitle: "Den komplette avlsmodul til hoppeejere og avlere — fra bedækning til føl, i én tidslinje.",
    primaryCTA: {
      label: "Aktivér Avlsmodul",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se funktioner",
      href: "#features",
    },
    audience: "Til avlere, hoppeejere og stalde der håndterer flere hopper.",
    features: [
      "Cyklussporing",
      "Registrering af løbetid",
      "Registrering af inseminationsdatoer",
      "Nedtælling til scanninger",
      "Planlæg drægtighedskontroller",
      "Stamtavle og afstamning",
      "Følудvikling",
      "Oversigt over alle drægtige hopper",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per måned · Avlsmodul inkluderet i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Kom i gang i dag",
      title: "Start med avlsstyring.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Hovslager-modul",
    title: "Arbejd smartere som hovslager. Dokumentér alt professionelt.",
    subtitle: "Kalender, fotos, bemærkninger og behandlingshistorik i ét modul — mindre miscommunikation, stærkere journal.",
    primaryCTA: {
      label: "Start som hovslager",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional-pakken",
      href: "/professional",
    },
    audience: "Til hovslagere der ønsker bedre overblik, dokumentation og kundekommunikation.",
    features: [
      "Egen kalender",
      "Aftaler pr. kunde",
      "Se hesteprofiler",
      "Tilføj før- og efterfotos",
      "Notér behandling",
      "Registrér råd og bemærkninger",
      "ETA-besked til kunde: \"Hovslageren er på vej\"",
    ],
    benefits: [
      "Mere professionel arbejdsgang",
      "Mindre miscommunikation",
      "Bedre journalopbygning",
      "Stærkere ved ansvarsspørgsmål",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Pr. måned · Hovslager-modul inkluderet i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktivér Hovslager-modulet.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Tandlæge modul",
    title: "Et komplet tandlægejournal per hest.",
    subtitle: "Registrer fund, behandlinger og opfølgning direkte i EquiSight.",
    primaryCTA: {
      label: "Start som hestandlæge",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional Bundel",
      href: "/professional",
    },
    audience: "Hestandlæger, dyrlæger og klinikker, der ønsker at arbejde struktureret.",
    features: [
      "Registrer tandeftersyn",
      "Fund per behandling",
      "Tilføj fotos",
      "Rapport til ejer",
      "Opfølgningsråd",
      "Historik per hest",
      "Planlæg ny aftale",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · Tandlæge modul inkluderet i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktiver Tandlæge Modul.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Fysio / Osteo modul",
    title: "Følg krop, bevægelse og genoptræning professionelt.",
    subtitle: "Til fysioterapeuter og osteopater, der ønsker at vejlede heste struktureret.",
    primaryCTA: {
      label: "Start som fysio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Professional Bundel",
      href: "/professional",
    },
    features: [
      "Indtagelse pr. hest",
      "Registrer kropsundersøgelser",
      "Tilføj billeder og videoer",
      "Opret behandlingsrapport",
      "Del øvelser og opfølgning",
      "Følg genoptræningsforløb",
      "Historik pr. hest",
    ],
    benefits: [
      "Bedre indsigt over tid",
      "Professionel rapportering",
      "Tydelig kommunikation med ejer, træner og rytter",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · Fysio / Osteo modul inkluderet i Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktivér Fysio / Osteo Modul.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trænermodul",
    title: "Coacher ryttere med data, mål og fremskridt.",
    subtitle: "Gør træning målbar og vejledning mere professionel — for én eller flere ryttere.",
    primaryCTA: {
      label: "Start som træner",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Pro-pakken",
      href: "/#pricing",
    },
    audience: "Til instruktører, trænere og coaches med flere ryttere eller heste.",
    features: [
      "Tilknyt ryttere",
      "Følg heste",
      "Sæt træningsmål",
      "Giv feedback",
      "Analysér konkurrenceresultater",
      "Se fremskridt per kombination",
      "Brug protokolanalyser til træningsfokus",
    ],
    benefits: [
      "Bedre vejledning",
      "Mere struktur",
      "Mere professionel kommunikation",
      "Stærkere relation til kunder",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per måned · Trænermodul inkluderet i Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Aktivér Trænermodulet.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Stævneanalyse",
    title: "Fra protokol til præstationsforbedring.",
    subtitle: "Upload dit stævneprotokol og opdag, hvor du mister point — ikke kun se din score, men forstå, hvordan du bliver bedre.",
    primaryCTA: {
      label: "Analysér dit første protokol",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se Premium",
      href: "/premium",
    },
    features: [
      "Upload protokolfoto",
      "Behandle for- og bagside",
      "Genkende klasse, prøvenummer og dommer",
      "Analysere scorer pr. disciplin",
      "Opsummere kommentarer",
      "Vise styrker og svagheder",
      "Tendenser pr. hest-rytter-kombination",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per måned · stævneanalyse inkluderet fra Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Kom i gang med stævneanalyse.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional-pakke",
    title: "For fagfolk omkring hesten.",
    subtitle: "Hovslager, tandlæge, fysio, osteo eller træner: samarbejd i ét digitalt hestejournalsystem.",
    primaryCTA: {
      label: "Start som fagperson",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Se individuelle moduler",
      href: "#features",
    },
    audience: "Professional-pakken kombinerer alle fagmoduler i ét abonnement.",
    features: [
      "Hovslagermodul",
      "Tandlægemodul",
      "Fysio / Osteo-modul",
      "Kalender & kundehåndtering",
      "Hesteprofiler & rapporter",
      "Behandlingshistorik & journalopbygning",
      "Kommunikation med ejer",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per måned · alle fagmoduler inkluderet",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Klar?",
      title: "Vælg Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Nødnumre til hest",
    title: "Altid den rette hjælp inden for rækkevidde.",
    subtitle: "I en nødsituation tæller hvert sekund. Med EquiSight har du alle vigtige kontaktoplysninger til din hest klar med det samme — ét tryk og du ringer.",
    primaryCTA: {
      label: "Gør dine nødkontakter klar",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Start gratis med EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Nødkontakter — ring direkte, send WhatsApp eller naviger til dyrlæge, klinik og smed",
      caption: "Ét tryk. Ingen panik og søgen.",
      embeddedFrame: true,
    },
    problem: "Din hest har det skidt — kolik, skade, panik. Og så begynder søgningen. Hvem ringer du til? Har du det rigtige nummer? Er dette akutnummeret? Kostbar tid går tabt.",
    solution: "Med EquiSight har du alt klar med det samme. Ingen søgen. Ingen tvivl. Ét tryk og du har kontakt.",
    scenario: {
      title: "Forestil dig — din hest viser tegn på kolik.",
      steps: [
        "Du åbner EquiSight",
        "Trykker på \"Dyrlæge\"",
        "Ringer direkte",
      ],
      tagline: "Ingen stress. Ingen søgen. Kun handling.",
    },
    features: [
      "Alle nødnumre samlet ét sted",
      "Ring med ét tryk fra appen",
      "Send WhatsApp med ét tryk",
      "Naviger direkte til adressen",
      "Individuel kontaktliste pr. hest",
      "Dyrlæge, klinik, smed, tandlæge, fysioterapeut",
      "Adresse og vejbeskrivelse tilgængelig med det samme",
      "Markér favoritnumre med en stjerne",
      "Akutnumre (112, 144) altid øverst",
    ],
    benefits: [
      "Ro og kontrol i en nødsituation",
      "Alle på stalden har de samme numre klar",
      "Ingen glemte visitkort mere",
      "Reager sekunder hurtigere ved akutte situationer",
    ],
    audience: "Til hestejere, pasningsansvarlige, trænere og stalde — alle der er ansvarlige for en hest.",
    showcase: {
      eyebrow: "Sat op for dig på forhånd",
      title: "13 kategorier af kontakter — klar til at udfylde.",
      description: "Fra dyrlæge og akutklinik til saddelmager, instruktør og græsningsforvalter. EquiSight kender din verden og har de rigtige kontaktfelter klar til dig. Tryk, udfyld, færdig.",
      bullets: [
        "Nød & sundhed — dyrlæge, akut, klinik, forgiftningslinje",
        "Daglig pleje — smed, tandlæge, fysioterapeut, instruktør",
        "Stald & græsning — staldejer, græsningsforvalter, pensionsstald",
        "Foder & materialer — hø-, kraftfoder- og strøleverandører",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Skærmbillede til håndtering af nødkontakter — alle foreslåede kontakter pr. kategori",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Tjekliste over nødnumre til hest",
      items: [
        "Dyrlæge",
        "Akutklinik (24/7)",
        "Dyreambulance · 144",
        "Smed",
        "Backup-kontaktperson",
        "Generelt alarmnummer · 112",
      ],
      cta: {
        label: "Åbn i EquiSight og udfyld med det samme",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Nødnumre",
          price: "Gratis",
          note: "Altid gratis · for alle, i ethvert abonnement",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Sørg for at være forberedt",
      title: "Inden du får brug for det.",
      href: "/#waitlist",
    },
    microcopy: [
      "Ingen forpligtelser",
      "Klar på 2 minutter",
      "Altid tilpasselig",
    ],
  },
};

export default LANDINGS;
